<div hidden>
  <dsd-container>
    <dsd-fieldset></dsd-fieldset>
    <dsd-button variant="compact"></dsd-button>
    <dsd-input name="prefetch"></dsd-input>
    <dsd-form-error-summary></dsd-form-error-summary>
    <dsd-form-hint></dsd-form-hint>
  </dsd-container>
</div>
